import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { BlockchainApplicationService } from "src/app/services/blockchain-application.service";
import { Router } from "@angular/router";
import { BlockchainDashboardModel } from "src/app/model/BlockchainDashboardModel";
import { LineChartDataModel } from "src/app/model/LineChartDataModel";
import { Page } from "src/app/model/Page";
import { BlockchainPendingDocsView } from "src/app/model/BlockchainPendingDocsView";
import { MatSort } from "@angular/material/sort";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-secure-blockchain-dashboard",
  templateUrl: "./blockchain-dashboard.component.html",
  styleUrls: ["./blockchain-dashboard.component.scss", "./external.component.scss"],
})
export class BlockchainDashboardComponent implements OnInit, AfterViewInit {
  isLoading = false;
  filterForm: FormGroup = new FormGroup({});
  boardList: {[key: number]: string};
  lotteryList: {[key: number]: string};
  schemeList: {[key: number]: string};
  
  boardId: number;
  lotteryId: number;
  schemeId: number;
  cur_year: number = new Date().getFullYear();

  blockchainDashboard: BlockchainDashboardModel;
  
  filteredListParams: {
    boardId: number,
    lotteryId: number,
    schemeId: number,
  };

  chartOptions;
  chartOptionsBoardWise;

  blockchainPendingList : Page<BlockchainPendingDocsView>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<BlockchainPendingDocsView> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "applicationNo",
    "reportType",
    "createdOn",
    "action",    
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  
  peerClass = 'defaultNode';
  bcDocFolderSize: number;

  constructor(
    private blockchainApplicationService: BlockchainApplicationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loadScript();
    this.fetchBoards();
    this.onDataLoad();

    this.fetchPendingList();
    
    this.filterForm = new FormGroup({
      boardId: new FormControl({key: null, value: 'All Boards'}),
      lotteryId: new FormControl({key: null, value: 'All Lotteries'}),
      schemeId: new FormControl({key: null, value: 'All Schemes'}),
    });
  }

  resetFilter() {
    this.filteredListParams = null;
    this.boardId = null;
    this.lotteryId = null;
    this.schemeId = null;
    this.lotteryList = null;
    this.schemeList = null;
    this.ngOnInit();
  }
  
  onDataLoad() {
    this.isLoading = true;
    this.blockchainDashboard = null;
    this.chartOptions = null;
    this.chartOptionsBoardWise = null;
    this.filteredListParams = {
      boardId: this.filterForm.value?.boardId?.key,
      lotteryId: this.filterForm.value?.lotteryId?.key,
      schemeId: this.filterForm.value?.schemeId?.key,
    };
  
    this.blockchainApplicationService.fetchBlockchainDashboard(this.filteredListParams).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.blockchainDashboard = data;
          this.initializeChart(this.blockchainDashboard.chartData, this.blockchainDashboard.chartYear);
          this.initializeChartBoardWise(this.blockchainDashboard.chartDataBoardWise);

          setTimeout(() => {
            this.initializePeerChart(this.blockchainDashboard.peerCount);
          }, 3000);

          console.log(((this.blockchainDashboard.bcDocFolderSize / (1024 * 1024 * 1024)) * 100));
          this.bcDocFolderSize = parseInt(((this.blockchainDashboard.bcDocFolderSize / (1024 * 1024 * 1024)) * 100) + '');
        }
        else {
          this.blockchainApplicationService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  fetchBoards() {
    this.isLoading = true;
    this.blockchainApplicationService.initFormFetchBoard().subscribe((data) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.boardList = data.lst;
        if(this.boardId) {
          let selectedBoard = this.boardList[this.boardId];
          if(selectedBoard) {
            this.filterForm.patchValue({
              boardId: {key: this.boardId, value: selectedBoard}
            });
          }

          this.fetchLotteries({key: this.boardId, value: selectedBoard});
        }
      }
      else {
        this.blockchainApplicationService.errorToast(data.errorMessage);
      }
    }, (error) => {
      this.isLoading = false;
      this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
    });
  }

  showSelectedObject(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1;
    }
    else {
      return "";
    }
  }

  fetchLotteries(b: {key: number, value: string}) {
    this.boardId = b.key;
    this.lotteryId = null;
    this.schemeId = null;
    this.lotteryList = [];
    this.schemeList = [];

    if(b?.key) {
      this.isLoading = true;
      this.blockchainApplicationService.initFormFetchLottery(b.key).subscribe((data1) => {
        this.isLoading = false;
  
        if(data1.status === 'SUCCESS') {
          this.lotteryList = data1.lst;
          this.onDataLoad();
        }
        else {
          this.blockchainApplicationService.errorToast(data1.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
      });
    }
    else {
      this.onDataLoad();
    }
  }

  fetchSchemes(l: {key: number, value: string}) {
    this.lotteryId = l.key;
    this.schemeId = null;
    this.schemeList = [];
    
    if(l?.key) {
      this.isLoading = true;
      this.blockchainApplicationService.initFormFetchScheme(this.boardId, l.key).subscribe((data2) => {
        this.isLoading = false;
  
        if(data2.status === 'SUCCESS') {
          this.schemeList = data2.lst;
          this.onDataLoad();
        }
        else {
          this.blockchainApplicationService.errorToast(data2.errorMessage);
        }
      }, (error) => {
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.errorMessage?.errorMessage);
      });
    }
    else {
      this.onDataLoad();
    }
  }

  onSchemeChange(s: {key: number, value: string}) {
    if(s?.key) {
      this.onDataLoad();
    }
    else {
      this.onDataLoad();
    }
  }

  dashboardDetail(letterType: string) {
    if(this.filterForm.value?.boardId?.key) {
      if(this.filterForm.value?.lotteryId?.key) {
        if(this.filterForm.value?.schemeId?.key) {
          this.router.navigate(['/secure', 'verify-blockchain', letterType, this.filterForm.value?.boardId?.key, 
          this.filterForm.value?.lotteryId?.key, this.filterForm.value?.schemeId?.key], { replaceUrl: true });
        }
        else {
          this.router.navigate(['/secure', 'verify-blockchain', letterType, this.filterForm.value?.boardId?.key, 
          this.filterForm.value?.lotteryId?.key], { replaceUrl: true });
        }
      }
      else {
        this.router.navigate(['/secure', 'verify-blockchain', letterType, this.filterForm.value?.boardId?.key], { replaceUrl: true });
      }
    }
    else {
      this.router.navigate(['/secure', 'verify-blockchain', letterType], { replaceUrl: true });
    }
  }

  initializeChart(data: LineChartDataModel[], chartYear: number) {
    this.chartOptions = {
      animationEnabled: true,  
      title:{
        text: "Blockchain Documents - "+ chartYear,
        fontFamily: "tahoma",
      },
      axisX: {
        title: "Month"
      },
      axisY: { 
        title: "Count"                   
      },
      toolTip: {
        shared: true
      },
      legend: {
        cursor:"pointer",
        itemclick: function(e: any) {
          if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible ){
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        }
      },
      data: data.map(o => {
        return {
          type: "stackedColumn",
          showInLegend: true,
          name: o.lineName,
          dataPoints: o.lst.map(o2 => {return {label: o2.x, y: o2.y}})
        }
      })
    };
  }

  initializeChartBoardWise(data: LineChartDataModel[]) {
    this.chartOptionsBoardWise = {
      animationEnabled: true,  
      title:{
        text: "Boardwise Blockchain Documents",
        fontFamily: "tahoma",
      },
      axisX: {
        title: "Boards"
      },
      axisY: { 
        title: "Count"                   
      },
      toolTip: {
        shared: true
      },
      legend: {
        cursor:"pointer",
        itemclick: function(e: any) {
          if (typeof(e.dataSeries.visible) === "undefined" || e.dataSeries.visible ){
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        }
      },
      data: data.map(o => {
        return {
          type: "stackedColumn",
          showInLegend: true,
          name: o.lineName,
          dataPoints: o.lst.map(o2 => {return {label: o2.x, y: o2.y}})
        }
      })
    };
  }

  fetchChart(chartYear: number) {
    this.isLoading = true;
    this.blockchainDashboard.chartData = null;
    this.chartOptions = null;
    this.filteredListParams = {
      boardId: this.filterForm.value?.boardId?.key,
      lotteryId: this.filterForm.value?.lotteryId?.key,
      schemeId: this.filterForm.value?.schemeId?.key,
    };
  
    this.blockchainApplicationService.fetchBlockchainDashboardChart({
      ...this.filteredListParams, chartYear
    }).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.blockchainDashboard.chartData = data.chartData;
          this.blockchainDashboard.chartYear = data.chartYear;
          this.initializeChart(this.blockchainDashboard.chartData, this.blockchainDashboard.chartYear);
        }
        else {
          this.blockchainApplicationService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  fetchPendingList() {
    this.isLoading = true;    
    this.blockchainApplicationService.fetchPendingList(
      this.currentPage,
      this.pageSize
    ).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.blockchainPendingList = data.data;
          this.dataSource = new MatTableDataSource(data.data.content);
          
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.data.totalElements;
          });
        }
        else {
          this.blockchainApplicationService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }  

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.fetchPendingList();
  }

  pushDocument(applicationNo: string, reportType: string) {
    this.blockchainApplicationService.pushBCDocs(applicationNo, reportType).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.blockchainApplicationService.successToast('Scheduled job for pushing '+applicationNo+'('+reportType+') to Blockchain');
          setTimeout(()=> {
            this.fetchPendingList();
          }, 10000);
        }
        else {
          this.blockchainApplicationService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.blockchainApplicationService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  initializePeerChart(peerCount: number) {
    if(peerCount - 5 > -5) {
      if(peerCount - 5 == 0) {
        this.peerClass = 'node1Live';
      }
      else if(peerCount - 5 == -1) {
        this.peerClass = 'node2Live';
      }
      else if(peerCount - 5 == -2) {
        this.peerClass = 'node3Live';
      }
      else if(peerCount - 5 == -3) {
        this.peerClass = 'node4Live';
      }
      else if(peerCount - 5 == -4) {
        this.peerClass = 'node5Live';
      }
      setTimeout(() => {
        this.initializePeerChart(--peerCount);
      }, 3000);
    }
  }

  loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = "https://github.hubspot.com/odometer/odometer.js";
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}
